/**
 * This `UTMController` is responsible for capturing and storing UTM parameters from the URL in the sessionStorage of the application.
 */
export class UTMController {
  private utmSourceKey = 'sessionUTMSourceTM';

  constructor() {
    this.checkAndSaveUTMParams();
  }

  private checkAndSaveUTMParams(): void {
    // checks if there are one UTM saved in this session
    if (sessionStorage.getItem(this.utmSourceKey)) return;

    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");

    if (utmSource) {
      const utmParams = Array.from(params.entries())
          .filter(([key]) => key.startsWith("utm_"))
          .map(([key, value]) => `${key}=${value}`)
          .join("&");

      sessionStorage.setItem(this.utmSourceKey, utmParams);
    }
  }

  // Method to check if there is an active UTM source
  hasUTMSource(): boolean {
    return !!sessionStorage.getItem(this.utmSourceKey);
  }

  // Method to get the saved UTM source
  getUTMSource(): string | null {
    return sessionStorage.getItem(this.utmSourceKey);
  }

  // Method to clear the UTM source
  clearUTMSource(): void {
    sessionStorage.removeItem(this.utmSourceKey);
  }
}
